/**
 * What the studio runs.
 *
 * The one inverted panel in the upper half of the page. It earns the ink
 * because it is the section a technical reader scans for a specific word —
 * "Django", "Flutter", "Odoo" — and the reversal makes it findable at a glance
 * while scrolling.
 *
 * A definition list rather than a grid of cards: these are labelled values, and
 * <dl> is what that is.
 */
import { Section } from '../components/Section';
import { useI18n } from '../i18n';
import styles from './Stack.module.css';

export function Stack() {
  const { t } = useI18n();

  return (
    <Section eyebrow={t.stack.eyebrow} tone="ink">
      <dl className={styles.grid}>
        {t.stack.groups.map((group) => (
          <div key={group.label} className={styles.row}>
            <dt className={styles.label}>{group.label}</dt>
            <dd className={styles.value}>{group.value}</dd>
          </div>
        ))}
      </dl>
      <p className={styles.note}>{t.stack.note}</p>
    </Section>
  );
}
